import { useEffect, useRef } from 'react';

/**
 * React-хук, хранящий предыдущее значение.
 *
 * @param {any} [value] - Текущее значение.
 * @returns {any} - Предыдущее значение.
 */
export const usePreviousValue = <Value>(value: Value): Value | undefined => {
  const prevValue = useRef<Value>(undefined);

  useEffect(() => {
    prevValue.current = value;
  }, [value]);

  return prevValue.current;
};
